module.exports = __webpack_public_path__ + "img/youmu konpaku lunar war gardener_sc1.b48948ae.png";